<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
   <div v-if="incomes">
          <v-card style="margin-bottom: 5px;padding: 5px">
            <div class="row">
              <h1 class="col-md-12">
                <v-btn @click="$router.go(-1)" outlined style="border: none;margin-right: 10px" title="Retourner"><v-icon>mdi mdi-arrow-left</v-icon></v-btn>
                {{$t('wallet')}} | {{wallet.devise._name}}
                <span style="float: right">
                 {{formatAmount(wallet._amount)}} {{wallet.devise._code_alpha}}
                </span>
              </h1>

            </div>
          </v-card>
      <div>
        <v-card>
          <v-tabs  v-model="tabs" color="#1C3071" grow >
            <v-tab  style="box-shadow: 0 1px 1px 0 rgba(0,0,0,0.2);transition: 0.3s; border-radius: 5px;">
              <v-icon >mdi mdi-cash-multiple</v-icon>
              <span style="margin-left: 5%"></span>
              {{$t('menus.transactions')}}
            </v-tab>
            <!--<v-tab style="box-shadow: 0 1px 1px 0 rgba(0,0,0,0.2);transition: 0.3s; border-radius: 5px;">
              <v-icon>mdi mdi-bank-transfer</v-icon>
              <span style="margin-left: 5%"></span>
              {{$t('menus.transferts')}}
            </v-tab>-->
            <v-tab  style="box-shadow: 0 1px 1px 0 rgba(0,0,0,0.2);transition: 0.3s; border-radius: 5px;">
              <v-icon>mdi mdi-cash-refund</v-icon>
              <span style="margin-left: 5%"></span>
              {{$t('menus.reversements')}}

            </v-tab>
            <!--<v-tab style="box-shadow: 0 1px 1px 0 rgba(0,0,0,0.2);transition: 0.3s; border-radius: 5px;">
              <v-icon>mdi mdi-credit-card-check</v-icon>
              <span style="margin-left: 5%"></span>
              {{$t('menus.recharges')}}
            </v-tab>-->

          </v-tabs>
          <v-tabs-items v-model="tabs">
            <!--TRANSACTION-->
            <v-tab-item>
              <v-card flat>
                <transactions :transactions="transactions" :devise="wallet.devise"></transactions>
              </v-card>
            </v-tab-item>
            <!--TRANSFERS-->
            <!--<v-tab-item>
              <v-card flat>
                <transfers :transfers="transfers" :devise="wallet.devise"></transfers>
              </v-card>
            </v-tab-item>-->
            <!--REVERSEMENTS-->
            <v-tab-item>
              <v-card flat>
                <reversements :reversements="reversements" :devise="wallet.devise"></reversements>
              </v-card>
            </v-tab-item>
            <!--RECHARGES-->
           <!-- <v-tab-item>
              <v-card flat>
                <recharges :recharges="recharges" :devise="wallet.devise"></recharges>
              </v-card>
            </v-tab-item>-->


          </v-tabs-items>

        </v-card>
      </div>
   </div>
  <div v-else class="col-lg-12 col-md-12 col-12 text-center loader_panel_component">
    <img src="/loaders/loader_turq.gif" alt=""><br>
    <span class="loader_text"> Chargement en cours ... </span>
  </div>
</template>

<script>
    /* eslint-disable */
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";
    import helpers from "../../../../mixins/helpers";
    import Transactions from "@/components/administrators/components/intramwallets/Transactions";
    import Reversements from "@/components/administrators/components/intramwallets/Reversements";

    export default {
      components: {Transactions, Reversements, },
      label: "IntramWalletDetails",
        mixins:[helpers(this)],
        data() {
            return {
              tabs: null,


            }
        }
        ,
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? this.$t('reversements.newtext') : this.$t('reversements.update')
            }
            ,
            ...mapState('intramwallets/', ['intramwallets','incomes','wallet']),
          transfers(){
            if (this.incomes){
              for (let i=0; i< this.incomes.length;i++){
                let datas = this.incomes[i];
                console.log(datas,"datas")
                if (datas._id === "transfer"){
                  return datas;
                }
              }
            }
          },
          transactions(){
            if (this.incomes){
              for (let i=0; i< this.incomes.length;i++){
                let datas = this.incomes[i];
                if (datas._id === "transaction"){
                  return datas;
                }
              }
            }
          },
          reversements(){
            if (this.incomes){
              for (let i=0; i< this.incomes.length;i++){
                let datas = this.incomes[i];
                if (datas._id === "reversement"){
                  return datas;
                }
              }
            }
          },
          recharges(){
            if (this.incomes){
              for (let i=0; i< this.incomes.length;i++){
                let datas = this.incomes[i];
                if (datas._id === "recharge"){
                  return datas;
                }
              }
            }
          },
        }
        ,
        mounted() {
            this.$store.dispatch('intramwallets/getWalletDetails',this.$route.params.id).then(response => {
                window.console.log('incomes ', response)
            });
        },
        methods: {
            initialize() {},
            checkisDashboard() {
                this.$emit('checkisDashboard', true);
            },
        },
        created() {
            this.checkisDashboard();
            this.initialize()
        }
    }
</script>

<style scoped>
.btn-custom-add{
  border-radius: 33px;
  padding: 2%;
}
</style>
